import { types } from 'mobx-state-tree';

const CodedValueModel = types.model('CodedValueModel', {
  code: types.maybe(types.union(types.number, types.string)),
  description: types.string,
  inactive: types.boolean
});

export const DomainModel = types.model('DomainModel', {
  domainName: types.string,
  codedValues: types.array(CodedValueModel)
});

const CodeNameModel = types.model('CodeNameModel', {
  code: types.maybe(types.union(types.number, types.string)),
  name: types.string
});

export const TADomainModel = types.model('TADomainModel', {
  domainName: types.string,
  codedValues: types.array(CodeNameModel)
});
